<template>
  <div>
    <div class="usps
      uk-hidden@m" uk-slideshow="
    autoplay: true;
    ratio: false;
    autoplay-interval: 3000;
    min-height: 75;
    max-height: 75px;
">
      <ul class="uk-slideshow-items">
        <slot />
      </ul>
    </div>

    <div class="usps-m uk-visible@m">
      <ul class="uk-list uk-flex uk-flex-around uk-flex-top">
        <slot />
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'USPMarquee.vue',
};
</script>
